var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 419.34 330.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0049e7;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill-rule:evenodd;}.cls-2{fill:#2ddaff;}.cls-3{fill:#0463ef;}.cls-4{fill:#15b0f8;}.cls-5{fill:#0f82c1;}.cls-6{fill:#021b8d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "289.73 137.91 199.49 137.91 143.34 220.25 242.19 220.25 289.73 137.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "212.67 89.67 160.9 0 0 240.19 49.27 329.79 212.67 89.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "230.53 240.44 282.3 330.12 419.34 92.76 367.57 3.09 234.74 233.14 230.53 240.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "174.7 256.01 99.34 256.01 48.86 329.87 217.34 329.87 174.7 256.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "99.34 256.01 48.86 329.87 61.68 329.87 99.34 256.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "289.73 137.91 230.08 220.25 242.19 220.25 289.73 137.91"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.807bbcc69800c5ddf3e4e7e4c0d71ea9.svg";
export { ForwardRef as ReactComponent };